<!-- 粉丝列表 -->
<template>
  <div
    style="
      background-color: #f0f2f5;
      margin: -20px -30px -30px;
      padding: 20px 30px 30px;
      min-height: calc(100vh - 65px);
    "
  >
    <!-- 标题 -->
    <div style="background-color: #fff; padding: 20px; margin-bottom: 20px">
      <div class="page-title">粉丝列表</div>
      <div
        style="
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          border-bottom: 1px solid #eee;
          margin-bottom: 20px;
          margin-top: 10px;
        "
      >
        <div class="screen-box">
          <div class="screen-label">渠道</div>
          <a-select
            show-search
            style="min-width: 200px"
            placeholder="请选择渠道"
            @change="handleChangeB"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            :value="r_channel_id"
          >
            <a-select-option
              v-for="(item, index) in bookList"
              :key="index"
              :value="item.key"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </div>

        <div class="screen-box">
          <div class="screen-label">公众号</div>
          <a-select
            show-search
            notFoundContent="← 请先选择: 书城"
            style="min-width: 200px"
            placeholder="请选择公众号"
            @change="handleChangeA"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            :value="r_gzh_id"
          >
            <a-select-option
              v-for="(value, key) in gzhSelect"
              :key="key"
              :value="key"
            >
              {{ value }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin: 10px 0 0;
        "
      >
        <!-- openid -->
        <div class="screen-box">
          <div class="screen-label">openid</div>
          <a-input
            v-model="r_openid"
            allowClear
            placeholder="请输入openid"
            style="width: 200px"
          />
        </div>
        <!-- 关注时间 -->

        <div class="screen-box">
          <div class="screen-label">关注时间</div>
          <a-range-picker
            style="width: 350px"
            :locale="locale"
            :show-time="{ format: 'HH:mm:ss' }"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDateC"
            @ok="onDateC_ok"
          />
        </div>

        <!-- 备注 -->
        <div class="screen-box">
          <div class="screen-label">备注</div>
          <a-input
            v-model="r_remark"
            allowClear
            placeholder="请输入备注"
            style="width: 200px"
          />
        </div>
        <!-- 标签 -->
        <div class="screen-box">
          <div class="screen-label">标签</div>
          <a-select
            mode="multiple"
            style="min-width: 200px; max-width: 600px"
            placeholder="未选择"
            :filter-option="filterOption"
            @change="handleChangeH"
            showSearch
            allowClear
          >
            <a-select-option
              v-for="(item, index) in sendTagData"
              :key="index"
              :value="item.tag_id"
            >
              {{ item.tag_name }}
              <!-- （ {{item.tag_count}} ） -->
            </a-select-option>
          </a-select>
        </div>
        <!-- 粉丝来源 -->
        <div class="screen-box">
          <div class="screen-label">粉丝来源</div>
          <a-select
            style="width: 200px"
            placeholder="未选择"
            :filter-option="filterOption"
            @change="handleChangeF"
            showSearch
            allowClear
          >
            <a-select-option value="1">公众号搜索</a-select-option>
            <a-select-option value="2">公众号迁移</a-select-option>
            <a-select-option value="3">名片分享</a-select-option>
            <a-select-option value="4">扫描二维码</a-select-option>
            <a-select-option value="5">图文页内名称点击</a-select-option>
            <a-select-option value="6">图文页右上角菜单</a-select-option>
            <a-select-option value="7">支付后关注</a-select-option>
            <a-select-option value="8">微信广告</a-select-option>
            <a-select-option value="0">其他</a-select-option>
          </a-select>
        </div>
        <!-- 粉丝名称 -->
        <div class="screen-box">
          <div class="screen-label">粉丝名称</div>
          <a-input
            v-model="r_nickname"
            allowClear
            placeholder="请输入"
            style="width: 200px"
          />
        </div>
        <!-- 性别 -->
        <div class="screen-box">
          <div class="screen-label">性别</div>
          <a-select
            style="width: 200px"
            placeholder="未选择"
            :filter-option="filterOption"
            @change="handleChangeS"
            showSearch
            allowClear
          >
            <a-select-option value="1">男</a-select-option>
            <a-select-option value="2">女</a-select-option>
            <a-select-option value="0">未知</a-select-option>
          </a-select>
        </div>

        <a-button
          class="screen-box"
          @click="searchButton('button')"
          :loading="search_button_loading"
          type="primary"
          icon="search"
          >搜索</a-button
        >
      </div>
    </div>

    <!-- <div style="display:flex;align-items: center;justify-content: flex-end;margin-bottom: 10px;">
		<div style="cursor: default;margin-right:20px;">共有<span style="color:#1890ff;">123</span>个粉丝</div>
		<div class="handle-button">打标签（0/20）</div>
		<div class="handle-button">一键标签</div>
		<div class="handle-button">删除标签</div>
	</div> -->

    <div style="background-color: #fff; padding: 20px 0 30px 20px">
      <div
        style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: 20px;
        "
      >
        <span style="cursor: default; margin-right: 20px"
          >共有<span style="color: #1890ff">{{ table_total }}</span
          >个粉丝</span
        >
        <a-tooltip placement="top">
          <template slot="title">
            <span>为选中的粉丝添加标签</span>
          </template>
          <a-button
            @click="clickHandle(1)"
            style="margin-right: 20px"
            type="primary"
            >打标签（{{ selectedData.length }}）</a-button
          >
        </a-tooltip>

        <a-tooltip placement="top">
          <template slot="title">
            <span>为筛选出的所有粉丝添加标签</span>
          </template>
          <a-button
            @click="clickHandle(2)"
            style="margin-right: 20px"
            type="primary"
            >一键标签</a-button
          >
        </a-tooltip>

        <a-button
          @click="clickHandle(3)"
          style="margin-right: 20px"
          type="primary"
          >删除标签</a-button
        >
      </div>
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div class="table-th-cell" :style="{ width: 50 + 'px' }">
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="onCheckAllChange"
          ></a-checkbox>
        </div>
        <div v-for="(item, index) in rableTitle" :key="index">
          <div class="table-th-cell" :style="{ width: item.width + 'px' }">
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <!-- 选择 -->
        <div class="table-td-cell" :style="{ width: 50 + 'px' }">
          <a-checkbox
            :checked="item.checked"
            @change="onChangeCheckbox($event, index)"
          ></a-checkbox>
        </div>
        <template v-for="(z_tem, z_ndex) in rableTitle">
          <div
            v-if="
              z_tem.type != 'nickname' &&
              z_tem.type != 'sex' &&
              z_tem.type != 'city' &&
              z_tem.type != 'tag_name_list' &&
              z_tem.type != 'subscribe_scene' &&
              z_tem.type != 'remark'
            "
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] }}
          </div>

          <div
            v-else-if="z_tem.type == 'nickname'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex; align-items: center"
          >
            <img
              v-if="item.headimgurl"
              style="width: 50px; height: 50px; margin-right: 5px"
              :src="item.headimgurl"
            />
            <div>{{ item[z_tem.type] }}</div>
            <!-- {{item[z_tem.type]}} -->
          </div>
          <div
            v-else-if="z_tem.type == 'sex'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] | sexFilters }}
          </div>
          <div
            v-else-if="z_tem.type == 'city'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item.country }} {{ item.province }} {{ item.city }}
          </div>
          <div
            v-else-if="z_tem.type == 'tag_name_list'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="display: flex; flex-wrap: wrap"
          >
            <template v-for="(item_z, index_z) in item[z_tem.type]">
              <div class="td-tag-box">
                <a-tag color="blue">{{ item_z }}</a-tag>
              </div>
              <!-- <div class="td-tag-box"><a-tag color="blue">{{item_z}}</a-tag></div> -->
            </template>
          </div>
          <div
            v-else-if="z_tem.type == 'subscribe_scene'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] | fansFilters }}
          </div>
          <div
            v-else-if="z_tem.type == 'remark'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] }}
            <a-icon
              @click="tdHandle(1, item)"
              type="form"
              style="cursor: pointer; margin-left: 5px"
            />
          </div>
        </template>
      </div>

      <!-- 表格内容为空时显示 -->
      <!-- <tableNull :tableShowData="tableShowData" :table_null_width="table_null_width"></tableNull> -->
      <div
        v-show="tableShowData.length === 0"
        style="text-align: center; margin: 80px 0 50px"
        :style="{ width: table_null_width + 'px' }"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />
        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
      </div>
      <div
        style="
          position: fixed;
          right: 0;
          bottom: 0;
          z-index: 6;
          background-color: #f0f2f5;
          height: calc(100vh - 65px);
          width: 30px;
        "
      ></div>
      <div
        style="
          position: fixed;
          left: 0;
          bottom: 0;
          z-index: 6;
          background-color: #f0f2f5;
          height: calc(100vh - 65px);
          width: 30px;
        "
      ></div>

      <!-- 分页 -->
      <pagingCompont
        :table_scroll_width="table_scroll_width"
        :table_null_width="table_null_width"
        :r_page="r_page"
        :r_limit="r_limit"
        :table_total="table_total"
        @pagination-Change="paginationChange"
        @change-size-limit="changeSizeLimit"
      ></pagingCompont>
    </div>

    <!-- 打标签 -->
    <a-modal
      :title="`为用户${tag_handle_type == 3 ? '删除' : '添加'}标签`"
      width="800px"
      :visible="tag_modal_visible"
      :confirm-loading="tag_modal_loading"
      @ok="tagHandleClick"
      @cancel="tagHandleCancelClick"
    >
      <div>
        <div class="form-cell-box">
          <div class="class-title">公众号</div>
          <div>{{ tag_gzh_name }}</div>
        </div>

        <div v-if="tag_handle_type == 2" class="form-cell-box">
          <div class="class-title">选择粉丝数</div>
          <div>{{ table_total }}</div>
        </div>
        <div v-else class="form-cell-box">
          <div class="class-title">选择粉丝数</div>
          <div>{{ selectedData.length }}</div>
        </div>

        <div class="form-cell-box" style="align-items: flex-start">
          <div
            v-if="tag_handle_type == 1 || tag_handle_type == 2"
            class="class-title"
          >
            添加标签
          </div>
          <div v-else-if="tag_handle_type == 3" class="class-title">
            删除标签
          </div>
          <div>
            <div style="margin-bottom: 10px">
              <div
                v-if="sendTagData.length > 0"
                style="
                  display: flex;
                  flex-wrap: wrap;
                  max-height: 300px;
                  overflow-y: auto;
                "
              >
                <div
                  v-for="(item, index) in sendTagData"
                  :key="index"
                  @click="selectTagClick(item)"
                  :class="[
                    item.select_status
                      ? 'tag-modal-box-true'
                      : 'tag-modal-box-false',
                  ]"
                  class="tag-modal-box"
                >
                  {{ item.tag_name }}
                </div>
              </div>
              <div v-else>空</div>
            </div>
            <div style="display: flex">
              <a-button
                @click="tagModalHandle(1)"
                v-if="tag_handle_type != 3"
                size="small"
                icon="plus"
                style="margin-right: 15px; display: block"
                type="primary"
                >新建标签</a-button
              >
              <a-button
                @click="tagModalHandle(2)"
                size="small"
                style="margin-right: 15px; display: block"
                :loading="sync_tag_loading"
                type="primary"
                >同步微信标签</a-button
              >
              <a-button
                @click="tagModalHandle(3)"
                size="small"
                type="primary"
                :loading="refresh_tag_loading"
                >刷新标签列表</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <a-modal
      :title="`新增标签`"
      width="800px"
      :visible="add_tag_visible"
      :confirm-loading="add_tag_loading"
      @ok="tagHandleOk"
      @cancel="tagHandleCancel"
    >
      <div>
        <div class="form_div">
          <div class="form-cell-box">
            <div class="class-title">名称</div>
            <a-input
              v-model="tag_list_params.name"
              placeholder="请输入标签名称"
            />
          </div>
          <div class="form-cell-box">
            <div class="class-title">类型</div>
            <a-select
              :options="GZH_LABEL_TYPE_LIST"
              style="width: 160px"
              v-model="tag_list_params.tag_type"
              placeholder="请选择标签类型"
              allowClear
            />
          </div>
          <div class="form-cell-box">
            <a-button
              type="primary"
              style="margin-left: 6px"
              @click="searchClick()"
              >搜索</a-button
            >
          </div>
        </div>
        <a-button type="primary" @click="jump()">新建标签</a-button>

        <a-table
          :loading="r_loading"
          :columns="columns"
          :data-source="local_tag_list"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :pagination="{
            defaultPageSize: 5,
            pageSize: 5,
            pageSizeOptions: ['3', '5', '8', '10'],
            total: r_total,
          }"
          @change="tagListChange"
        >
          <a slot="tag_type" slot-scope="tag_type">{{
            GZH_LABEL_TYPE_MAP[tag_type]
          }}</a>
        </a-table>
      </div>
    </a-modal>

    <!-- 打备注 -->
    <a-modal
      title="设置备注"
      width="500px"
      :visible="remark_visible"
      :confirm-loading="remark_loading"
      @ok="remarkOk"
      @cancel="remarkCancel"
    >
      <div>
        <div class="form-cell-box">
          <div class="class-title">备注名称</div>
          <a-input v-model="add_remark_name" placeholder="请输入备注名称" />
        </div>
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-if="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import moreSelect from "@/components/selectCompont/moreSelect.vue";
import gzhSearchMoreSelect from "@/components/selectCompont/searchSelect.vue";
import { GZH_LABEL_TYPE_LIST, GZH_LABEL_TYPE_MAP } from "./const.js";
import {
  gzhFansList,
  opeGzhSelect,
  wxMaterialTag,
  gzhFansCity,
  gzhFansAddTag,
  gzhFansSyncTag,
  gzhFansHandleTag,
  gzhFansQuickTag,
  wxMaterialSelect,
  materialChannelSelect,
  gzhFansRemark,
  getLocalGzhTagList,
} from "@/request/api";
export default {
  name: "gzhFans_",
  components: {
    moreSelect,
    gzhSearchMoreSelect,
  },
  data() {
    this.dateFormat = "YYYY-MM-DD";
    return {
      locale,
      GZH_LABEL_TYPE_LIST,
      GZH_LABEL_TYPE_MAP,
      selectedRowKeys: [],
      tag_list_params: {
        tag_type: undefined,
        name: undefined,
        limit: 5,
        page: 1,
      },
      local_tag_list: [],
      r_total: 0,
      r_loading: false,
      columns: [
        {
          title: "标签ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "标签名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "标签类型",
          dataIndex: "tag_type",
          key: "tag_type",
          scopedSlots: { customRender: "tag_type" },
        },
        {
          title: "标签描述",
          dataIndex: "remark",
          key: "remark",
        },
      ],
      moment,
      startTime: "2022-06-12",
      endTime: "2022-06-23",
      r_openid: "",
      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "粉丝", width: 120, type: "nickname" },
        { title: "openid", width: 200, type: "openid" },
        { title: "关注时间", width: 150, type: "subscribe_time" },
        { title: "性别", width: 90, type: "sex" },
        { title: "地区", width: 130, type: "city" },
        { title: "标签", width: 150, type: "tag_name_list" },
        { title: "粉丝来源", width: 150, type: "subscribe_scene" },
        // {title:"操作", width:180, type:"cz", },
        { title: "备注", width: 120, type: "remark" },
      ],
      tableShowData: [],
      table_scroll_width: 1000,
      table_null_width: 1000,

      search_button_loading: false,

      r_page: 1, // 页数
      r_limit: 50, // 每页多少条
      table_total: 0, // 表格内容总数

      r_start_time: null, // 开始时间
      r_end_time: null, // 结束时间
      r_channel_id: undefined, // 渠道
      r_gzh_id: undefined, // 公众号

      start_sub_time: null, // 关注起始时间
      end_sub_time: null, // 关注结束时间
      r_tag_id: undefined, // 标签
      r_sex: undefined, // 性别
      r_subscribe_scene: undefined, // 粉丝来源/关注渠道
      r_province: undefined, // 省份
      r_nickname: null, // 昵称
      r_remark: null, // 备注

      gzhSelect: [], // 公众号下拉

      searchSelect: {
        user: {},
        channel: {},
      }, // 渠道，公众号 下拉框数据

      visibleData: false,

      sendTagData: [], // 标签

      provinceData: [], // 省份选择

      // 为用户添加标签
      tag_modal_visible: false,
      tag_modal_loading: false,
      refresh_tag_loading: false,
      sync_tag_loading: false,

      tag_gzh_name: "", // 当前选择的公众号名字

      add_tag_visible: false,
      add_tag_loading: false,
      add_tag_name: "",

      // 多选
      indeterminate: false,
      checkAll: false,
      selectedData: [], // 选中的数据

      tag_handle_type: 1, // 打tag的类型，1是打标签，2是一键标签，3是删除标签

      bookList: [], // 渠道下拉
      gzhSelect: [], // 公众号下拉

      // 设置备注
      remark_visible: false,
      remark_loading: false,
      add_remark_name: "",
      remark_openid: "",
    };
  },
  mounted() {
    let that = this;
    that.search_button_loading = true;

    // 获取当前日期
    let date2 = new Date();
    let month2;
    if (date2.getMonth() + 1 < 10) {
      month2 = "0" + (date2.getMonth() + 1);
    } else {
      month2 = date2.getMonth() + 1;
    }
    let day2;
    if (date2.getDate() < 10) {
      day2 = "0" + date2.getDate();
    } else {
      day2 = date2.getDate();
    }
    that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
    that.startTime = that.endTime;

    // 获取表格信息
    let table_info = this.$getTableInfo(that.rableTitle, 50);
    that.body_width = table_info.body_width;
    that.table_scroll_width = table_info.table_width - 30;
    that.table_null_width = table_info.null_width - 30;
    materialChannelSelect().then((res) => {
      console.log("下拉", res);
      that.selectData = res.data.data;
      let c_data = res.data.data.channel;
      let show_data = [];
      for (let key in c_data) {
        let ooo = {
          key,
          label: c_data[key],
          status: false,
        };
        show_data.push(ooo);
      }
      // show_data[0].status = true
      that.bookList = show_data;
      console.log("show_data", show_data);
      that.r_channel_id = show_data[0].key;
      that.handleChangeB(show_data[0].key);
    });
  },
  methods: {
    tagHandleCancelClick() {
      this.tag_modal_visible = false;
      this.tag_modal_loading = false;
      this.sendTagData.forEach((res) => {
        res.select_status = false;
      });
    },
    // 为用户添加标签
    tagHandleClick() {
      let that = this;
      let t_data = [];
      that.sendTagData.forEach((res) => {
        if (res.select_status) {
          t_data.push(res.tag_id);
        }
      });
      if (t_data.length == 0) {
        that.$message.warning("请选择标签");
      } else {
        let o_data = [];
        that.selectedData.forEach((res) => {
          o_data.push(res.openid);
        });
        that.tag_modal_loading = true;
        if (that.tag_handle_type == 1 || that.tag_handle_type == 3) {
          // 1打标签, 3删除标签
          gzhFansHandleTag({
            gzh_id: that.r_gzh_id,
            tag_id: t_data,
            open_id: o_data,
            type: that.tag_handle_type == 1 ? "add" : "delete",
          }).then((res) => {
            that.tag_modal_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.tagHandleCancelClick();
              that.$message.success(res.data.msg);
              that.searchButton("tag");
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        } else {
          // 一键打标签
          gzhFansQuickTag({
            gzh_id: that.r_gzh_id, // 公众号
            channel_id: that.r_channel_id, // 书城/渠道
            tag_list: that.r_tag_id, // 标签查询数组
            start_subscribe_time: that.start_sub_time,
            end_subscribe_time: that.end_sub_time,
            sex: that.r_sex, // 性别
            subscribe_scene: that.r_subscribe_scene, // 粉丝来源
            nickname: that.r_nickname, // 昵称

            tag_id: t_data, // 需要打标签的id数组
            gzh_id: that.r_gzh_id, // 公众号ID
          }).then((res) => {
            console.log("一键标签");
            that.tag_modal_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.tagHandleCancel();
              that.$message.success(res.data.msg);
              that.searchButton("tag");
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        }
      }
    },

    showErrorList(list) {
      const text = list.join(",");
      this.$confirm({
        content: text,
        onOk() {},
        onCancel() {},
      });
    },
    tagHandleCancel() {
      this.add_tag_visible = false;
      this.add_tag_loading = false;
      this.sendTagData.forEach((res) => {
        res.select_status = false;
      });
    },
    // 为用户添加标签
    tagHandleOk() {
      let that = this;
      that.add_tag_loading = true;
      const names = [];
      for (let index = 0; index < this.selectedRowKeys.length; index++) {
        const element = this.selectedRowKeys[index];
        const item = this.local_tag_list[element];
        names.push(item.name);
      }
      gzhFansAddTag({
        gzh_id: that.r_gzh_id,
        name: names,
      })
        .then((res) => {
          that.add_tag_loading = false;
          // that.showErrorList([
          //   `A公众号创建失败失败原因：。。。`,
          //   `B公众号创建失败，失败原因xxxxx`
          // ]);
          if (res.data.data.err_list && res.data.data.err_list.length > 0) {
            that.showErrorList(res.data.data.err_list);
            return;
          } else if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.tagHandleCancel();
            that.$message.success("添加成功");
            that.getTagTable(that.r_gzh_id);
            that.searchButton();
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        })
        .catch(() => {
          that.add_tag_loading = false;
        });
    },
    searchClick() {
      this.tag_list_params = {
        ...this.tag_list_params,
        page: 1,
      };
      this.getGzhTagList();
    },
    tagListChange(pagination) {
      const { current, pageSize } = pagination;
      this.tag_list_params = {
        ...this.tag_list_params,
        limit: pageSize,
        page: current,
      };
      this.getGzhTagList();
    },
    onSelectChange(selectedRowKeys, item) {
      this.selectedRowKeys = selectedRowKeys;
    },
    async getGzhTagList() {
      try {
        this.r_loading = true;
        this.selectedRowKeys = [];
        const result = await getLocalGzhTagList({
          ...this.tag_list_params,
        });
        if (result.data.code === 0) {
          this.local_tag_list = result.data.data.data;
          this.r_total = result.data.data.total;
        }
      } catch (error) {
        this.r_loading = false;
      } finally {
        this.r_loading = false;
      }
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 日期选择
    onChangeDate(date, dateString) {
      // console.log(date, dateString);
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    onChangeDateC(value, dateString) {
      console.log("Selected Time: ", value);
      console.log("Formatted Selected Time: ", dateString);
      this.start_sub_time = dateString[0] || undefined;
      this.end_sub_time = dateString[1] || undefined;
    },
    onDateC_ok(value) {
      // console.log('onOk: ', value);
    },

    // 公众号
    handleChangeA(value) {
      let that = this;
      this.r_gzh_id = value;
      for (let key in this.gzhSelect) {
        if (key == value) {
          // 获取公众号名字
          this.tag_gzh_name = this.gzhSelect[key];
        }
      }

      this.searchButton("button");
      this.getGzhTag();
    },
    getGzhTag() {
      let that = this;
      this.refresh_tag_loading = true;
      wxMaterialTag({
        gzh_id: this.r_gzh_id,
      }).then((res) => {
        console.log("获取标签", res);
        that.refresh_tag_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          let data = res.data.data.data;
          data.forEach((res) => {
            res.select_status = false;
          });
          that.sendTagData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 获取公众号名字
    getGzhName(e) {
      console.log("获取公众号名字", e);
      this.tag_gzh_name = e;
    },
    // 书城
    handleChangeB(e) {
      this.r_channel_id = e;
      this.search_button_loading = true;
      this.getGzhSelect(e);
    },
    // 根据渠道获取公众号
    getGzhSelect(e) {
      let that = this;
      wxMaterialSelect({
        channel_id: e,
      }).then((res) => {
        that.search_button_loading = false;

        if (res.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          that.$router.replace({ name: "login", params: { type: "not_log" } });
          return;
        }

        console.log("根据渠道获取公众号", res);
        that.gzhSelect = res.data.data.list;
        that.r_gzh_id = Object.keys(res.data.data.list)[0];
        that.tag_gzh_name =
          res.data.data.list[Object.keys(res.data.data.list)[0]];
        that.handleChangeA(that.r_gzh_id);
      });
    },

    handleChangeH(e) {
      this.r_tag_id = e;
    },
    handleChangeS(e) {
      this.r_sex = e;
    },
    handleChangeF(e) {
      // 粉丝来源/关注渠道
      this.r_subscribe_scene = e;
    },
    handleChangeP(e) {
      // 省份
      this.r_province = e;
    },

    // 搜索
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;

      if (type == "button") {
        that.r_page = 1;
      }
      if (type == "button" || type == "tag") {
        // 每次点击搜索按钮就清空选中状态
        that.selectedData = [];
        that.checkAll = false;
        that.indeterminate = false;
      }

      let r_data = {
        page: that.r_page,
        limit: that.r_limit,
        gzh_id: that.r_gzh_id, // 公众号

        channel_id: that.r_channel_id, // 书城/渠道

        // gzh_id: 2, // 景中书卷公众号
        tag_list: that.r_tag_id, // 标签查询数组
        start_subscribe_time: that.start_sub_time,
        end_subscribe_time: that.end_sub_time,
        sex: that.r_sex, // 性别
        subscribe_scene: that.r_subscribe_scene, // 粉丝来源
        nickname: that.r_nickname, // 昵称
        remark: that.r_remark, // 备注
        openid: that.r_openid,
      };

      gzhFansList(r_data).then((res) => {
        that.search_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("搜索成功");
          that.table_total = res.data.data.total;
          let data = res.data.data.data;
          data.forEach((res) => {
            res.checked = false;
          });

          if (that.selectedData.length > 0) {
            let ccc = true;
            let iii = 0; // 用于判断是否全选
            data.forEach((res) => {
              that.selectedData.forEach((res_r) => {
                if (res.id === res_r.id) {
                  res.checked = true;
                  ccc = false;
                  iii = iii + 1;
                }
              });
            });
            console.log("iii", iii);
            if (iii === that.r_limit) {
              // 全选
              that.indeterminate = false;
              that.checkAll = true;
            } else {
              if (ccc) {
                that.checkAll = false;
                that.indeterminate = false;
              } else {
                that.checkAll = false;
                that.indeterminate = true;
              }
            }
          } else {
            console.log("that.checkAll", that.checkAll);
            that.checkAll = false;
            that.indeterminate = false;
          }

          that.tableShowData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 分页
    paginationChange(e) {
      let that = this;
      this.r_page = e;
      this.searchButton();
    },
    changeSizeLimit(e) {
      // console.log('每页多少条',e)
      this.r_limit = e;
      this.searchButton("button");
    },

    // 表格内的操作
    wxTdCz(e, item) {
      console.log("item", item);
      let that = this;
      if (e == 1) {
        // 消息管理
      }
    },

    // 操作按钮
    clickHandle(e) {
      this.tag_handle_type = e;
      let that = this;
      if (e == 1 || e == 3) {
        // 1打标签, 3删除标签
        if (this.selectedData.length > 0) {
          that.search_button_loading = true;
          wxMaterialTag({
            gzh_id: this.r_gzh_id,
          }).then((res) => {
            that.search_button_loading = false;
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
              return;
            }

            let data = res.data.data.data;
            data.forEach((res) => {
              res.select_status = false;
            });
            that.sendTagData = res.data.data.data;

            that.tag_modal_visible = true;
          });
        } else {
          this.$message.warning("请选择粉丝");
        }
      } else if (e == 2) {
        // 一键标签
        let that = this;
        // this.getGzhTag()
        that.search_button_loading = true;
        wxMaterialTag({
          gzh_id: this.r_gzh_id,
        }).then((res) => {
          if (res.data.code == 401) {
            // 未登录
            that.search_button_loading = false;
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
            return;
          }

          let data = res.data.data.data;
          data.forEach((res) => {
            res.select_status = false;
          });
          that.sendTagData = res.data.data.data;

          // 根据搜索条件重新获取列表数据
          let r_data = {
            page: 1,
            limit: that.r_limit,
            gzh_id: that.r_gzh_id, // 公众号
            channel_id: that.r_channel_id, // 书城/渠道
            // gzh_id: 2, // 景中书卷公众号

            tag_list: that.r_tag_id, // 标签查询数组
            start_subscribe_time: that.start_sub_time,
            end_subscribe_time: that.end_sub_time,
            sex: that.r_sex, // 性别
            subscribe_scene: that.r_subscribe_scene, // 粉丝来源
            nickname: that.r_nickname, // 昵称
            remark: that.r_remark, // 备注
          };
          // that.search_button_loading = true
          gzhFansList(r_data).then((res) => {
            that.search_button_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.table_total = res.data.data.total;
              let data = res.data.data.data;

              that.tableShowData = res.data.data.data;
              if (data.length > 0) {
                that.tag_modal_visible = true;
              } else {
                that.$message.warning("筛选出来的粉丝个数为0");
              }
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        });
      }
    },

    // // 为用户添加标签
    // tagHandleOk() {
    //   let that = this;
    //   let t_data = [];
    //   that.sendTagData.forEach((res) => {
    //     if (res.select_status) {
    //       t_data.push(res.tag_id);
    //     }
    //   });
    //   if (t_data.length == 0) {
    //     that.$message.warning("请选择标签");
    //   } else {
    //     let o_data = [];
    //     that.selectedData.forEach((res) => {
    //       o_data.push(res.openid);
    //     });
    //     that.tag_modal_loading = true;
    //     if (that.tag_handle_type == 1 || that.tag_handle_type == 3) {
    //       // 1打标签, 3删除标签
    //       gzhFansHandleTag({
    //         gzh_id: that.r_gzh_id,
    //         tag_id: t_data,
    //         open_id: o_data,
    //         type: that.tag_handle_type == 1 ? "add" : "delete",
    //       }).then((res) => {
    //         console.log("打标签", res);
    //         that.tag_modal_loading = false;
    //         if (
    //           res.data.code == 0 ||
    //           res.data.code == 200 ||
    //           res.data.code == 8011
    //         ) {
    //           that.tagHandleCancel();
    //           that.$message.success(res.data.msg);
    //           that.searchButton("tag");
    //         } else {
    //           if (res.data.code == 401) {
    //             // 未登录
    //             localStorage.removeItem("access_token");
    //             that.$router.replace({
    //               name: "login",
    //               params: { type: "not_log" },
    //             });
    //           } else {
    //             that.$message.error(`错误：${res.data.msg}`);
    //           }
    //         }
    //       });
    //     } else {
    //       // 一键打标签
    //       gzhFansQuickTag({
    //         gzh_id: that.r_gzh_id, // 公众号
    //         channel_id: that.r_channel_id, // 书城/渠道
    //         tag_list: that.r_tag_id, // 标签查询数组
    //         start_subscribe_time: that.start_sub_time,
    //         end_subscribe_time: that.end_sub_time,
    //         sex: that.r_sex, // 性别
    //         subscribe_scene: that.r_subscribe_scene, // 粉丝来源
    //         nickname: that.r_nickname, // 昵称

    //         tag_id: t_data, // 需要打标签的id数组
    //         gzh_id: that.r_gzh_id, // 公众号ID
    //       }).then((res) => {
    //         console.log("一键标签");
    //         that.tag_modal_loading = false;
    //         if (
    //           res.data.code == 0 ||
    //           res.data.code == 200 ||
    //           res.data.code == 8011
    //         ) {
    //           that.tagHandleCancel();
    //           that.$message.success(res.data.msg);
    //           that.searchButton("tag");
    //         } else {
    //           if (res.data.code == 401) {
    //             // 未登录
    //             localStorage.removeItem("access_token");
    //             that.$router.replace({
    //               name: "login",
    //               params: { type: "not_log" },
    //             });
    //           } else {
    //             that.$message.error(`错误：${res.data.msg}`);
    //           }
    //         }
    //       });
    //     }
    //   }
    // },

    // 选择标签
    selectTagClick(item) {
      console.log("选择标签", item);
      item.select_status = !item.select_status;
    },
    // 标签弹窗操作按钮
    tagModalHandle(e) {
      let that = this;
      if (e == 1) {
        // 新建标签
        this.add_tag_visible = true;
        this.getGzhTagList();
      } else if (e == 2) {
        // 同步微信标签
        this.sync_tag_loading = true;
        gzhFansSyncTag({
          gzh_id: this.r_gzh_id,
        }).then((res) => {
          this.sync_tag_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            console.log("同步微信标签", res);
            that.$message.success(res.data.msg);
          } else {
            // 这里不能加401的判断，因为返回来的报错就是401，但是并不是登录过期的401
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      } else if (e == 3) {
        // 刷新标签列表
        this.getGzhTag();
      }
    },

    addTagOk() {
      let that = this;
      if (!this.add_tag_name) {
        this.$message.warning("请输入标签名称");
      } else {
        this.add_tag_loading = true;
        gzhFansAddTag({
          name: this.add_tag_name,
          gzh_id: this.r_gzh_id,
        }).then((res) => {
          // console.log("标签",res)
          this.add_tag_loading = false;
          if (res.data.code == 0 || res.data.code == 200) {
            console.log("同步微信标签", res);
            that.addTagCancel();
            that.getGzhTag();
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      }
    },
    addTagCancel() {
      this.add_tag_visible = false;
      this.add_tag_loading = false;
    },

    // 多选测试
    onChangeCheckbox(checkedList, index) {
      let that = this;
      if (that.tableShowData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.tableShowData[index].checked = false;

        let iii;
        console.log(
          "that.tableShowData[index].id",
          that.tableShowData[index].id
        );
        that.selectedData.forEach((res, index_z) => {
          if (res.id == that.tableShowData[index].id) {
            iii = index_z;
          }
        });
        that.selectedData.splice(iii, 1);
        console.log("iii", iii);
      } else {
        // 未选中状态改为选中状态
        that.tableShowData[index].checked = true;
        if (that.selectedData.length === 0) {
          that.selectedData.push(that.tableShowData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.selectedData.length; i++) {
            if (that.selectedData[i].id === that.tableShowData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.selectedData.push(that.tableShowData[index]);
          }
        }
      }
      // that.tableShowData[index].checked = !that.tableShowData[index].checked
      console.log("that.selectedData", that.selectedData);
      let ccc = true;
      let iii = false;
      let nnn = that.selectedData.length || 0;
      console.log("that.selectedData.length", that.selectedData.length);
      that.tableShowData.forEach((res) => {
        if (res.checked) {
          iii = true;
          // nnn = nnn + 1
        }
        if (!res.checked) {
          ccc = false;
        }
      });
      // console.log("nnn",nnn)
      if (ccc) {
        that.indeterminate = false;
      } else {
        that.indeterminate = iii;
      }
      that.checkAll = ccc;
      that.selected_number = nnn;
    },
    // 全选
    onCheckAllChange(e) {
      let that = this;
      if (that.checkAll) {
        that.tableShowData.forEach((res) => {
          res.checked = false;
        });
        that.checkAll = false;
        // that.selected_number = 0

        that.selectedData = []; // 取消全选的时候，全部清除
      } else {
        that.tableShowData.forEach((res) => {
          res.checked = true;
          // 有重复的就不要传了
          let ddd = true;
          that.selectedData.forEach((res_r) => {
            if (res_r.id === res.id) {
              ddd = false;
              console.log("l", ddd);
            }
          });

          if (ddd) {
            console.log("w", ddd);
            that.selectedData.push(res);
          }
        });
        // that.selected_number = that.tableShowData.length
        that.indeterminate = false;
        that.checkAll = true;
      }
    },

    tdHandle(e, item) {
      if (e == 1) {
        this.remark_openid = item.openid;
        this.add_remark_name = item.remark;
        this.remark_visible = true;
      }
    },
    // 设置备注
    remarkOk() {
      let that = this;
      that.remark_loading = true;
      gzhFansRemark({
        openid: this.remark_openid,
        remark: this.add_remark_name,
      }).then((res) => {
        console.log("设置备注", res);
        that.remark_loading = false;
        if (res.data.code == 0 || res.data.code == 200) {
          console.log("同步微信标签", res);
          that.$message.success("设置成功");
          that.remarkCancel();
          that.searchButton();
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      });
    },
    remarkCancel() {
      this.remark_loading = false;
      this.remark_visible = false;
    },
  },
  filters: {
    logData_status(value) {
      let vvv = "";
      if (value == 0) {
        vvv = "待发送";
      } else if (value == 1) {
        vvv = "成功";
      } else if (value == 2) {
        vvv = "失败";
      }
      return vvv;
    },
    msgTypeFilters(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "文本";
      } else if (value == 2) {
        vvv = "图片消息";
      } else if (value == 3) {
        vvv = "单条图文消息";
      } else if (value == 4) {
        vvv = "多条图文消息";
      }
      return vvv;
    },
    sexFilters(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "男";
      } else if (value == 2) {
        vvv = "女";
      } else if (value == 0) {
        vvv = "未知";
      }
      return vvv;
    },
    fansFilters(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "公众号搜索";
      } else if (value == 2) {
        vvv = "公众号迁移";
      } else if (value == 3) {
        vvv = "名片分享";
      } else if (value == 4) {
        vvv = "扫描二维码";
      } else if (value == 5) {
        vvv = "图文页内名称点击";
      } else if (value == 6) {
        vvv = "图文页右上角菜单";
      } else if (value == 7) {
        vvv = "支付后关注";
      } else if (value == 8) {
        vvv = "微信广告";
      } else if (value == 0) {
        vvv = "其他";
      }
      return vvv;
    },
  },
};
</script>

<style scoped>
.screen-box {
  margin-bottom: 20px;
}
/* .table-td-cell {
	font-size: 14px;
} */
/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 12px;
  /* margin-bottom: 5px; */
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}

.form-cell-box {
  margin-bottom: 20px;
}

.msg-cell-title {
  margin-bottom: 10px;
}

.left-box {
  /* padding: 15px; */
  /* border: 1px solid #ccc; */
  position: sticky;
  top: 70px;
  width: 300px;
  background: #fff;
  padding: 23px;
}
.left-box-border {
  border: 2px solid #409eff;
}
.left-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 12px;
}
.left-cell-top {
  position: relative;
  cursor: pointer;
}
.left-cell-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px;
}
.left-cell-box-boder {
  border-bottom: 1px solid #e8e8e8;
}
.left-cell-img {
  width: 50px;
  height: 50px;
}
.left-cell-operation {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 7px;
  background-color: rgba(0, 0, 0, 0.7);
}
.left-cell-top:hover .left-cell-operation {
  display: flex;
}
.left-cell-box:hover .left-cell-operation {
  display: flex;
}
.left-cell-operation-icon {
  color: #fff;
  font-size: 16px;
}
.left-cell-add {
  text-align: center;
  font-size: 16px;
  padding: 15px 0 5px;
  cursor: pointer;
}

.cover-handle {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* display: flex; */
  align-items: center;
  justify-content: space-around;
}
.cover-box:hover .cover-handle {
  display: flex;
}

.type-3:hover .cover-handle {
  display: flex;
}

.td-tag-box {
  margin-right: 7px;
  margin-bottom: 3px;
}

/* 按钮 */
.handle-button {
  padding: 5px 10px;
  /* height: 24px; */
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 13px;
  /* color: #40a9ff;
	border: 1px solid #40a9ff; */
  cursor: pointer;
  color: #1890ff;
  border: 1px solid #1890ff;

  margin-right: 20px;
}
.handle-button:hover {
  background-color: #1890ff;
  color: #fff;
}

.tag-modal-box {
  padding: 2px 9px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 13px;
  cursor: pointer;

  margin-right: 20px;
  margin-bottom: 7px;
}
.tag-modal-box-true {
  color: #1890ff;
  border: 1px solid #1890ff;
  background-color: #e8efff;
}
.tag-modal-box-false {
  color: #333;
  border: 1px solid #f7f8fa;
  background-color: #f7f8fa;
}
.form_div {
  display: flex;
}
.class-title {
  width: 40px;
}
</style>
